import validator from 'validatorjs';
import { sanitizeDocument } from 'shared/utils/sanitizeDocument';

const WEIGHTS_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const WEIGHTS_DV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

function calculateDigit(document: string, weights: number[]) {
  let sum = 0;
  for (let i = 0; i < weights.length; i++) {
    sum += (document.charCodeAt(i) - 48) * weights[i];
  }
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
}

function validate(cnpj: string) {
  const document = sanitizeDocument(cnpj);

  if (document.length !== 14 || document === document[0].repeat(14)) {
    return false;
  }

  if (!/^\d{2}$/.test(document.slice(12))) {
    return false;
  }

  const digit1 = calculateDigit(document, WEIGHTS_DV1);
  if (digit1 !== Number(document.charAt(12))) {
    return false;
  }

  const digit2 = calculateDigit(document, WEIGHTS_DV2);
  return digit2 === Number(document.charAt(13));
}

validator.register('cnpj', validate, 'invalid_cnpj');
